<template>
  <div class="questionnaire-question-content">
    <div id="question" class="questionnaire-question-phrase"></div>

    <div v-if="image != null && image != ''" class="questionnaire-question-explanation">
      <img :src="require(`@/assets/img/question/${image}`)">
    </div>

    <div class="questionnaire-question-question">

      <div id="statement"></div>
      <div>
        <div v-for="proposition of propositions" :key="proposition">
          <div v-if="this.answer == proposition" :value=proposition class="col-md-8 questionnaire-question-proposition-selected" tabindex="0" v-on:click="focus">
            <div class="questionnaire-question-proposition-choix">
              {{ proposition }}
            </div>
          </div>
          <div v-else :value=proposition class="col-md-8 questionnaire-question-proposition" tabindex="0" v-on:click="focus">
            <div class="questionnaire-question-proposition-choix">
              {{ proposition }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from "@/services/user.service";
import {nextTick} from "vue";

export default {
  name: "ExpressionSelectGoodResponse",
  props: {
    question: String,
    statement: String,
    image: String
  },
  data() {
    return {
      answer: null,
      propositions: null
    }
  },
  methods: {
    focus: function (event) {
      var actual = document.getElementsByClassName('questionnaire-question-proposition-selected')[0]
      if (actual != undefined) {
        actual.classList.remove('questionnaire-question-proposition-selected')
        actual.classList.add('questionnaire-question-proposition')
      }
      event.currentTarget.classList.remove('questionnaire-question-proposition')
      event.currentTarget.classList.add('questionnaire-question-proposition-selected')
      this.answer = event.currentTarget.getAttribute('value')
    },
  },
  mounted() {
    document.getElementById('question').innerHTML = this.question
    document.getElementById('statement').innerHTML = this.statement

    this.propositions = this.$parent.propositions

    var domainId = this.$parent.domainId
    var indexQuestion = this.$parent.indexQuestion

    UserService.getUserTestQuestions(domainId).then(
        (response) => {
          var arrayResponses = response.data.responses
          var index = (indexQuestion - 1)
          this.answer = null
          if (arrayResponses[index] != undefined) this.answer = arrayResponses[index]['answer']

          nextTick(()=>{
            this.$parent.pageIsLoaded = true
          })
        }
    );
  },
};
</script>
